// const state = process.env.NODE_ENV === "development";
const state = false;

export default {
  state,
  DEFAULT_APP_URL: "app",
  streamsList: {
    limitOnPage: 5
  }
};
